<template>
    <h1>Niet gevonden.</h1>
</template>

<script>
    export default {}
</script>